import { createSlice } from '@reduxjs/toolkit';

export const authIsReady = createSlice({
  name: 'authIsReady',
  initialState: {
    data: false,
  },

  reducers: {
    setAuthIsReady: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setAuthIsReady } = authIsReady.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.isLoading`
export const getAuthIsReady = (state) => state.authIsReady.data;

export default authIsReady.reducer;
